.textInput{
    right:80px;
    width: calc(100% - 80px);
}

.sendButton{
    position: absolute;
    right: 10px;
    bottom: 10px;
}